export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const copyToClipboard = (text) => {
  var dummy = document.createElement("textarea");
  // to avoid breaking orgain page when copying more words
  // cant copy when adding below this code
  // dummy.style.display = 'none'
  document.body.appendChild(dummy);
  //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
  dummy.value = text;
  dummy.select();

  try {
    document.execCommand("copy");
    document.body.removeChild(dummy);
    return true;
  } catch (err) {
    return false;
  }
};

export const zeroPad = (num, places) => {
  var zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
};

// storage
export const setStorage = (name, data) => {
  window.localStorage.setItem(name, data);
};

export const getStorage = (name, isObject = false) => {
  const data = window.localStorage.getItem(name);

  return isObject ? JSON.parse(data) : data;
};

export const clearStorage = () => {
  window.localStorage.clear();
};

export const getCurrLang = () => {
  const path = window.location.pathname;

  if (path.indexOf("/en/") > -1) {
    return "en";
  }

  if (path.indexOf("/tc/") > -1) {
    return "tc";
  }

  return "sc";
};

export const scrollToError = ($formEl) => {
  console.debug("scrollToError");
  const errorWrapperEl = $formEl.querySelector('[data-has-errors="true"]');
  const errorWrapperInput =
    errorWrapperEl &&
    errorWrapperEl.querySelector(
      "input[type='text'], input[type='radio'], input[type='checkbox'], select,textarea",
    );
  if (errorWrapperInput) {
    errorWrapperInput.focus();
    errorWrapperEl.scrollIntoView({ block: "center" });
  }
};
